import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
import SogForm from "@/shared/ui/SogForm.vue";
import Address from "@/shared/model/Address";
import {computed, onBeforeMount, reactive, ref, watch} from "vue";
import {countries} from "@/shared/model/Country";
import SogFormValidationRule from "@/shared/ui/types/SogFormValidationRule";
import PersonAddressEditComponent from "@/modules/OrganisationStructure/components/PersonAddressEditComponent.vue";

interface Props {
  address:Address
  showFullName?:boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AddressEditComponent',
  props: {
    address: { default: () => {
        const t = new Address();
        t.countryCode = "DE"
        return t;
      } },
    showFullName: { type: Boolean, default: true }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const _form = ref<InstanceType<typeof SogForm>  | null>(null)

const _fullHouseNumber = ref("")
const _value = reactive({address:props.address,fullHouseNumber:_fullHouseNumber})
const _countryCode = ref(props.address.countryCode)

const _countries = countries;
const _fieldsCountries =  { text: 'countryName', value: 'countryCode' }

const _validations:SogFormValidationRule[]=[];

const _showFullName = computed(()=>{
  return props.showFullName && props.showFullName===true
})

watch( props,  () => {
      _value.address = props.address;

      _countryCode.value = _value.address.countryCode ?? ""
      _fullHouseNumber.value =
        (_value.address.houseNumber != null ? _value.address.houseNumber.toString() : "")
        + (_value.address.houseNumberAddition ?? "")
      // deep: Props sind shallowReactive – ohne deep feuert der Watch nur bei
      // Referenzwechsel, nicht wenn address in-place mutiert wird.
    },{immediate:true, deep:true}

)

watch((_fullHouseNumber),(value)=>{
  const a = value.match(/^\d+/g)
  if(a &&a.length>0){
    _value.address.houseNumber = parseInt(a[0])
    _value.address.houseNumberAddition = value.substring(a[0].length)
  }
  else {
    // houseNumber mitleeren, sonst stellt der deep-Watch den alten Wert im Feld wieder her
    _value.address.houseNumber = undefined
    _value.address.houseNumberAddition = value
  }

})


watch((_countryCode),(value)=>{
  _form.value?.removeRules("PostalCode")

  if(_form.value&&value==="DE"){
    _form.value?.addRules(  {name:'PostalCode',rules:{required:[true,"Die Postleitzahl muss aus genau fünf Ziffern bestehen"], minLength:[5,"Die Postleitzahl muss aus genau fünf Ziffern bestehen"],maxLength:[5,"die Postleitzahl muss aus genau fünf Ziffern bestehen"]}} )
  }
  else {
    _form.value?.addRules(  {name:'PostalCode',rules:{maxLength:[8,"Die Postleitzahl muss maximal aus 8 Ziffern bestehen"]}} )
  }
  _value.address.countryCode = value
}, {immediate:true})


onBeforeMount(()=>{

  _validations.push({name:'Street',rules:{required:[true,"Geben Sie mindestens eine Adresszeile ein."]}})
  if (props.address.countryCode === "DE") {
    _validations.push({
      name: 'PostalCode',
      rules: {
        required: [true, "Die Postleitzahl muss aus genau fünf Ziffern bestehen"],
        minLength: [5, "Die Postleitzahl muss aus genau fünf Ziffern bestehen"],
        maxLength: [5, "die Postleitzahl muss aus genau fünf Ziffern bestehen"]
      }
    })
  }
  else {
    _validations.push({
      name: 'PostalCode',
      rules: { maxLength: [8, "Die Postleitzahl muss maximal aus 8 Ziffern bestehen"] }
    })

  }
})
const validate = ( ):boolean => {
  if(_form.value)
    return _form.value.validate();
  return false;
}
const getAddress = ():Address => {
  return _value.address;
}

__expose({
  validate,getAddress
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogForm, {
    ref_key: "_form",
    ref: _form,
    validations: _validations
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(SogFormField, null, {
          default: _withCtx(() => [
            _createVNode(SogTextBox, {
              modelValue: _value.address.fullName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_value.address.fullName) = $event)),
              placeholder: "Abweichende Name",
              autocomplete: "true",
              name: "FullName",
              width: "220px"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(SogFormField, null, {
          default: _withCtx(() => [
            _createVNode(SogTextBox, {
              modelValue: _value.address.line1,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_value.address.line1) = $event)),
              placeholder: "Zusatz",
              autocomplete: "true",
              name: "Line1",
              width: "220px"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, _showFullName.value]
      ]),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _value.address.street,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_value.address.street) = $event)),
            placeholder: "Strasse",
            autocomplete: "true",
            name: "Street",
            width: "220px"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _value.fullHouseNumber,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_value.fullHouseNumber) = $event)),
            placeholder: "Hausnummer",
            autocomplete: "true",
            name: "HouseNumber",
            width: "220px"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _value.address.postalCode,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_value.address.postalCode) = $event)),
            placeholder: "Postleitzahl",
            autocomplete: "true",
            name: "PostalCode",
            "max-length": "8",
            width: "220px"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _value.address.city,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_value.address.city) = $event)),
            placeholder: "Stadt",
            autocomplete: "true",
            name: "City",
            width: "220px"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogDropDownList, {
            modelValue: _countryCode.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_countryCode).value = $event)),
            placeholder: "Land",
            "data-source": _unref(_countries),
            fields: _fieldsCountries,
            name: "Country",
            width: "220px"
          }, null, 8, ["modelValue", "data-source"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})